import React from "react";
import 'emoji-mart/css/emoji-mart.css';
import { Picker } from 'emoji-mart';
import Tooltip from 'react-tooltip-lite';

function TextArea(props) {

    const
        [height, setHeight] = React.useState(41),
        [emojisSatus, showEmojis] = React.useState(false),
        [text, setText] = React.useState(""),
        textArea = React.createRef();

    const onTextChange = (el) => {
        const { value, scrollHeight } = el.target;
        if (height !== scrollHeight) {
            setHeight((value === "" ? 41 : scrollHeight));
        }

        setText(value);
    }

    const onEnterPress = (e) => {
        if (e.keyCode === 13 && e.shiftKey === false) {
            onSend(e);
        }
    }

    const onSelectEmoji = (emoji) => {
        setText(text + " " + emoji.native);
        if (height !== textArea.current.scrollHeight) {
            setHeight(textArea.current.scrollHeight);
        }
    }

    const onSend = (e)=>{
        e.preventDefault();
        
        if (text.trim() !== ""){
            props.onSend(text);
            setText("");
            setHeight(41);
            showEmojis(false);
        }
        
    }

    return (
        <React.Fragment>
            <form className="Forum__header_Post" onSubmit={onSend}>
                <img className="Forum__header_img" src={props.photoURL} alt="profile" />
                <textarea
                    ref={textArea}
                    className="Forum__header_text"
                    style={{ height: `${height}px` }}
                    onChange={onTextChange}
                    onKeyDown={onEnterPress} 
                    value={text}
                    placeholder={props.placeholder}></textarea>

                <button type="button" onClick={() => { showEmojis(!emojisSatus) }} className="Forum__header_button emojis">
                    <Tooltip content="Insertar emoji" direction="bottom">
                        <i className="far fa-laugh"></i>
                    </Tooltip>
                </button>
                <button type="submit" className="Forum__header_button">
                    <Tooltip content="Enviar" direction="bottom">
                        <i className="fas fa-paper-plane"></i>
                    </Tooltip>
                </button>
            </form>
            <div className={"Forum__header_emojiPicker" + (emojisSatus ? " show" : " hide")}>
                <Picker
                    onSelect={onSelectEmoji}
                    style={{ width: "100%" }}
                    title='Pick your emoji…'
                    emoji='point_up'
                    set='apple' />
            </div>
        </React.Fragment>
    )
}

export default TextArea;


